import { render, staticRenderFns } from "./bar-block.vue?vue&type=template&id=632cdd43&scoped=true&"
import script from "./bar-block.vue?vue&type=script&lang=ts&"
export * from "./bar-block.vue?vue&type=script&lang=ts&"
import style0 from "./bar-block.vue?vue&type=style&index=0&id=632cdd43&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632cdd43",
  null
  
)

export default component.exports